import { SpwkUtilV3 } from "../../dao/SpwkUtilV3";
import { UniAnswer } from "../../dao/UniAnswer";
import { ExportBundle } from "../ExportBundle";
import { HisBasic } from "../HisBasic";
import { GovRowDto, HisBasicDto, HisDto, HisRowDto, } from "./HisDto";

export class HisDtoManager {

  static IHOSP = process.env.REACT_APP_IHOSP;

  static ConvertFromExportBundle(export_bundle: ExportBundle): HisDtoResult {

    let rslt: HisDtoResult = new HisDtoResult();

    let his_dto: HisDto = new HisDto();

    if (export_bundle.SourceUniAnswer == null) {
      return rslt.PushError("缺少來源 UniAnswer !!!");
    }

    let ans = export_bundle.SourceUniAnswer;

    //-------------------------------------------------------------------
    填寫共用核心欄位(rslt, his_dto, ans, export_bundle.AllHisBasicList);
    if (rslt.ErrorList.length !== 0) {
      return rslt.PushError(`填寫核心資料時發生錯誤 !!!`);// 發現累積的錯誤;
    }

    //-------------------------------------------------------------------
    let all_basic_list = export_bundle.AllHisBasicList;
    for (const basic of all_basic_list) {
      /** 處理 這個受檢者 的 單一特作 */
      let 作業編號 = basic.作業編號;
      let basic_dto: HisBasicDto
      let his_row_dto_list: HisRowDto[]
      let gov_row_dto_list: HisRowDto[]
      //yao
      if (作業編號 === 'A98') {
        basic_dto = GetA98問卷基礎(rslt, 作業編號, export_bundle)
        his_row_dto_list = GetA98問卷明細(rslt, 作業編號, export_bundle);
        gov_row_dto_list = GetA98問卷申報(rslt, 作業編號, export_bundle);
      } else {
        basic_dto = Get問卷基礎(rslt, 作業編號, export_bundle);
        his_row_dto_list = Get問卷明細(rslt, 作業編號, export_bundle);
        gov_row_dto_list = Get問卷申報(rslt, 作業編號, export_bundle);
      }
      if (rslt.ErrorList.length !== 0) {
        return rslt.PushError(`轉換[${作業編號}]發生錯誤 !!!`);// 發現累積的錯誤;
      }

      his_dto.問卷基礎.push(basic_dto);
      his_dto.問卷明細 = his_dto.問卷明細.concat(his_row_dto_list);
      his_dto.問卷申報 = his_dto.問卷申報.concat(gov_row_dto_list);
    }
    //-------------------------------------------------------------------

    rslt.HisDto = his_dto;// 轉檔完成
    return rslt;
  }

}

export class HisDtoResult {

  HisDto: HisDto | null = null;
  WarningList: string[] = [];
  ErrorList: string[] = [];

  PushError(error_message: string): HisDtoResult {
    this.ErrorList.push(error_message);
    return this;
  }

  PushWarning(error_message: string): HisDtoResult {
    this.WarningList.push(error_message);
    return this;
  }

}

function 填寫共用核心欄位(rslt: HisDtoResult, his_dto: HisDto, ans: UniAnswer, AllHisBasicList: HisBasic[]) {

  let 檢查日期 = "";
  let 公司編號 = "";
  let isn = "";
  let 身份證號 = "";
  let 性別 = "";
  let 姓名 = "";
  let 生日 = "";
  let 受雇日期 = "";
  let gender = "";
  let ihosp = HisDtoManager.IHOSP;
  for (const his_basic of AllHisBasicList) {
    if (his_basic.作業編號 === 'A98') {
      if (ans.member_gender === 1) {
        gender = 'M'
      } else if (ans.member_gender === 2) {
        gender = 'F'
      } else {
        rslt.ErrorList.push('請確認受檢者性別')
      }
      性別 = 檢查空白或相同才能放入_且數值必填(性別, gender, rslt);
      姓名 = 檢查空白或相同才能放入_且數值必填(姓名, ans.member_name, rslt);
    } else {
      性別 = 檢查空白或相同才能放入_且數值必填(性別, his_basic.性別, rslt);
      姓名 = 檢查空白或相同才能放入_且數值必填(姓名, his_basic.姓名, rslt);
    }
    檢查日期 = 檢查空白或相同才能放入_且數值必填(檢查日期, his_basic.檢查日期, rslt);
    公司編號 = 檢查空白或相同才能放入_且數值必填(公司編號, his_basic.公司編號, rslt);
    isn = 檢查空白或相同才能放入_且數值必填(isn, ans.member_code, rslt);
    身份證號 = 檢查空白或相同才能放入_且數值必填(身份證號, his_basic.身份證號, rslt);
    生日 = 檢查空白或相同才能放入_且數值必填(生日, his_basic.生日, rslt);
    受雇日期 = 檢查空白或相同才能放入_且數值必填(受雇日期, his_basic.受雇日期, rslt);
  }

  his_dto.檢查日期 = 檢查日期;
  his_dto.公司編號 = 公司編號;
  if(ihosp !== undefined && ihosp !== null){
    his_dto.ihosp = ihosp;
  }else{
    his_dto.ihosp ="";
  }  
  his_dto.isn = isn;
  his_dto.身份證號 = 身份證號;
  his_dto.性別 = 性別;
  his_dto.姓名 = 姓名;
  his_dto.生日 = 生日;
  his_dto.受雇日期 = 受雇日期;
}

function Get問卷基礎(rslt: HisDtoResult, 作業編號: string, export_bundle: ExportBundle): HisBasicDto {
  let re = new HisBasicDto();

  /* 撈出指定作業的資料 */
  let finds = export_bundle.AllHisBasicList.filter(x => x.作業編號 === 作業編號);
  if (finds.length !== 1) {
    rslt.PushError(`找不到[${作業編號}]的基本檔!`);
    return re;
  }
  /**/

  let basic: any = finds[0];

  re.作業編號 = basic.作業編號;
  re.曾經從事 = basic.曾經從事;
  re.曾經從事開始日 = basic.曾經從事開始日;
  re.曾經從事結束日 = basic.曾經從事結束日;
  re.目前從事 = basic.目前從事;
  re.目前從事開始日 = basic.目前從事開始日;
  re.目前從事結束日 = basic.目前從事結束日;
  re.一個月平均工時 = basic.一個月平均工時;
  re.六個月平均工時 = basic.六個月平均工時;
  re.平均睡眠時間 = basic.平均睡眠時間;
  re.本作業平均工時 = basic.本作業平均工時;
  re.是否輪班 = basic.是否輪班;
  re.輪班幾班制 = basic.輪班幾班制;
  re.輪班幾班制_其他 = basic.輪班幾班制_其他;
  re.目前從事開始月 = basic.目前從事開始月;// "10301(民國年月)",
  re.特殊危害健康作業編號 = basic.特殊危害健康作業編號;
  re.一個月夜間工作日數 = basic.一個月夜間工作日數;
  re.六個月夜間工作日數 = basic.六個月夜間工作日數;
  re.一年內夜間工時 = basic.一年內夜間工時;
  re.一年內夜間工作日數 = basic.一年內夜間工作日數;
  re.工作班別 = basic.工作班別;
  re.其它輪班班別 = basic.其它輪班班別;
  re.上班時間 = basic.上班時間;
  re.下班時間 = basic.下班時間;
  re.工作日平均睡眠時間 = basic.工作日平均睡眠時間;
  re.休息日平均睡眠時間 = basic.休息日平均睡眠時間;

  return re;
}


function Get問卷明細(rslt: HisDtoResult, 作業編號: string, export_bundle: ExportBundle): HisRowDto[] {
  rslt.PushWarning("TODO: 檢查是否每個欄位都有數值");

  let dto_list: HisRowDto[] = [];

  /* 撈出指定作業的資料 */
  let his_rows = export_bundle.AllHisRowList.filter(x => x.作業編號 === 作業編號);
  if (his_rows.length === 0) {
    rslt.PushError(`[${作業編號}]特作問卷沒有資料?`);
    return dto_list;
  }
  /**/

  for (const his_row of his_rows) {
    let dto: HisRowDto = new HisRowDto();
    dto.作業編號 = his_row.作業編號;
    dto.類別 = his_row.類別;
    dto.項目 = his_row.項目;
    dto.結果 = his_row.結果;
    dto.備註 = his_row.備註;

    dto_list.push(dto);
  }

  return dto_list;
}

function Get問卷申報(rslt: HisDtoResult, 作業編號: string, export_bundle: ExportBundle): GovRowDto[] {

  let dto_list: GovRowDto[] = [];

  /* 撈出指定作業的資料 */
  let gov_rows = export_bundle.AllGovRowList.filter(x => x.作業編號 === 作業編號);
  if (gov_rows.length === 0 && 作業編號 !== SpwkUtilV3.FUNC_CODE_A01) {
    rslt.PushError(`[${作業編號}]申報沒有資料?`);
    return dto_list;
  }
  /**/

  for (const gov_row of gov_rows) {
    let dto: GovRowDto = new GovRowDto();
    dto.作業編號 = gov_row.作業編號;
    dto.問題類別 = gov_row.問題類別;
    dto.問題編號 = gov_row.問題編號;
    dto.答題內容 = gov_row.答題內容;
    dto.答題內容_1 = gov_row.答題內容_1;
    dto.答題內容_2 = gov_row.答題內容_2;
    dto.答題內容_3 = gov_row.答題內容_3;
    dto.答題內容_4 = gov_row.答題內容_4;

    dto_list.push(dto);
  }

  return dto_list;
}

//yao-A98問卷
function GetA98問卷基礎(rslt: HisDtoResult, 作業編號: string, export_bundle: ExportBundle): HisBasicDto {
  let re = new HisBasicDto();

  /* 撈出指定作業的資料 */
  let finds = export_bundle.AllHisBasicList.filter(x => x.作業編號 === 作業編號);
  if (finds.length !== 1) {
    rslt.PushError(`找不到[${作業編號}]的基本檔!`);
    return re;
  }
  /**/

  let basic: any = finds[0];

  re.目前從事開始月 = basic.目前從事開始月;// "10301(民國年月)",
  re.特殊危害健康作業編號 = basic.特殊危害健康作業編號;
  re.一個月平均工時 = basic.一個月平均工時;
  re.一個月夜間工作日數 = basic.一個月夜間工作日數;
  re.六個月平均工時 = basic.六個月平均工時;
  re.六個月夜間工作日數 = basic.六個月夜間工作日數;
  re.一年內夜間工時 = basic.一年內夜間工時;
  re.一年內夜間工作日數 = basic.一年內夜間工作日數;
  re.工作班別 = basic.工作班別;
  re.其它輪班班別 = basic.其它輪班班別;
  re.上班時間 = basic.上班時間;
  re.下班時間 = basic.下班時間;
  re.工作日平均睡眠時間 = basic.工作日平均睡眠時間;
  re.休息日平均睡眠時間 = basic.休息日平均睡眠時間;

  re.作業編號 = basic.作業編號;
  re.目前從事 = basic.目前從事;
  re.目前從事開始日 = basic.目前從事開始日;
  re.目前從事結束日 = basic.目前從事結束日;
  re.平均睡眠時間 = basic.平均睡眠時間;
  re.本作業平均工時 = basic.本作業平均工時;
  re.是否輪班 = basic.是否輪班;
  re.輪班幾班制 = basic.輪班幾班制;
  re.輪班幾班制_其他 = basic.輪班幾班制_其他;

  return re;
}

function GetA98問卷明細(rslt: HisDtoResult, 作業編號: string, export_bundle: ExportBundle): HisRowDto[] {
  rslt.PushWarning("TODO: 檢查是否每個欄位都有數值");

  let dto_list: HisRowDto[] = [];

  /* 撈出指定作業的資料 */
  let his_rows = export_bundle.AllHisRowList.filter(x => x.作業編號 === 作業編號);
  if (his_rows.length === 0) {
    rslt.PushError(`[${作業編號}]特作問卷沒有資料?`);
    return dto_list;
  }
  /**/

  for (const his_row of his_rows) {
    let dto: HisRowDto = new HisRowDto();
    dto.作業編號 = his_row.作業編號;
    dto.類別 = his_row.類別;
    dto.項目 = his_row.項目;
    dto.結果 = his_row.結果;
    dto.備註 = his_row.備註;
    dto_list.push(dto);
  }
  return dto_list;
}
function GetA98問卷申報(rslt: HisDtoResult, 作業編號: string, export_bundle: ExportBundle): GovRowDto[] {

  let dto_list: GovRowDto[] = [];

  /* 撈出指定作業的資料 */
  let gov_rows = export_bundle.AllGovRowList.filter(x => x.作業編號 === 作業編號);
  if (gov_rows.length === 0 && 作業編號 !== SpwkUtilV3.FUNC_CODE_A01) {
    rslt.PushError(`[${作業編號}]A98申報沒有資料?`);
    return dto_list;
  }
  /**/
  for (const gov_row of gov_rows) {
    let dto: GovRowDto = new GovRowDto();
    dto.作業編號 = gov_row.作業編號;
    dto.問題類別 = gov_row.問題類別;
    dto.問題編號 = gov_row.問題編號;
    dto.答題內容 = gov_row.答題內容;
    dto.答題內容_1 = gov_row.答題內容_1;
    dto.答題內容_2 = gov_row.答題內容_2;
    dto.答題內容_3 = gov_row.答題內容_3;
    dto.答題內容_4 = gov_row.答題內容_4;
    dto_list.push(dto);
  }

  return dto_list;
}
function 檢查空白或相同才能放入_且數值必填(to_value: string, from_value: string, his_dto_rslt: HisDtoResult): string {
  let re = to_value;

  if (from_value === "") {
    his_dto_rslt.PushError(`46841 基本檔缺少必要數值!`);
  }

  if (re === '') {
    re = from_value;// 首次沒數值時可以設定
  } else if (re !== from_value) {
    his_dto_rslt.PushError(`46841 ${to_value} ${from_value} 基本檔兩次數值不同!`);
  }

  return re;
}